import React, { useState } from "react";
import MetaTags from "react-meta-tags";
import { Button, Card, CardBody, Col, Container, FormGroup, Label, Row } from "reactstrap";
import { Link } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { parse } from "papaparse"; // Using Papaparse for CSV parsing
import { importQuestionsParsedData } from "../../services/QuestionsService";

function ImportQuestionCsv() {
    const [formDataValues, setFormDataValues] = useState({});
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [questionData, setQuestionData] = useState({});


    const handleSubmit = (formDataValues) => {
        if (!formDataValues.file) {
            setErrorMessage("Please select a CSV file.");
            return;
        }

        parse(formDataValues.file, {
            header: true,
            complete: handleParsedData,
            error: handleParseError,
        });
       
    };

    const handleParsedData = (result) => {
      // Handle parsed data here
      console.log('Parsed data:', result.data);
      // Now you can set the parsed data to state or perform any other necessary actions
      // For example:
      setQuestionData(result.data);
      importQuestionsParsedData(result.data);
    };

    const handleParseError = (error) => {
        setErrorMessage("Error parsing CSV file.");
        console.error('L36:::Error parsing CSV file.',error);
    };

    const handleFileChange = (event) => {
      const file = event.target.files[0];
      const allowedExtensions = /(\.csv)$/i;
      
      if (!allowedExtensions.exec(file.name)) {
          setErrorMessage("Please upload a valid .csv file.");
          setFormDataValues({ ...formDataValues, file: null });
      } else {
          setErrorMessage("");
          setFormDataValues({ ...formDataValues, file });
      }

    };

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Bulk Upload</title>
                </MetaTags>
                <Row className="mb-3">
                    <Col sm="6">
                        <h5 className="text-uppercase"></h5>
                    </Col>
                    <Col sm="6" style={{ display: "flex", justifyContent: "flex-end" }}>
                        <a href={process.env.PUBLIC_URL + "/sample/QuestionSample.csv"} className="btn btn-outline-secondary" download>
                            Download CSV Sample Format
                        </a>
                        <Link to="/questions-list" className="btn btn-primary">
                            Back To Listing
                        </Link>
                    </Col>
                </Row>
                <Container fluid>
                    <Breadcrumbs title="Questions" breadcrumbItem="Import Questions csv" />
                    <Row>
                        <Col lg="12">
                            <Card>
                                <CardBody>
                                    <AvForm
                                        className="outer-repeater"
                                        onValidSubmit={() => {
                                            handleSubmit(formDataValues);
                                        }}
                                    >
                                        <div data-repeater-list="outer-group" className="outer">
                                            <div data-repeater-item className="outer">
                                                {successMessage && (
                                                    <div className="alert alert-success" role="alert">
                                                        {successMessage}
                                                    </div>
                                                )}
                                                {errorMessage && (
                                                    <div className="alert alert-danger" role="alert">
                                                        {errorMessage}
                                                    </div>
                                                )}

                                                <FormGroup className="mb-4" row>
                                                    <Label htmlFor="department_name" className="col-lg-3 col-form-label">
                                                        Upload CSV File
                                                        <span className="text-danger">*</span>
                                                    </Label>
                                                    <Col lg="9">
                                                        <AvField
                                                            type="file"
                                                            className="form-control"
                                                            id="file"
                                                            name="file"
                                                            errorMessage="Department Name Required."
                                                            onChange={handleFileChange}
                                                            accept=".csv"
                                                        />
                                                    </Col>
                                                </FormGroup>
                                            </div>
                                        </div>

                                        <div data-repeater-list="outer-group" className="outer">
                                            <br></br>
                                            <Row className="justify-content-end">
                                                <Col lg={9}>
                                                    <Button type="submit" color="success">
                                                        Submit
                                                    </Button>
                                                    &nbsp;
                                                    <Button type="button" onClick={() => window.location.reload()}>
                                                        Cancel
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </div>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
}

export default ImportQuestionCsv;
